// ported from src/web/style/_breakpoints.scss

export const BREAKPOINT_MOBILE = '48em';
export const BREAKPOINT_MEDIUM = '64em';
export const BREAKPOINT_DESKTOP = '1170px';
export const BREAKPOINT_TOP_BAR_MOBILE = BREAKPOINT_MOBILE;
export const BREAKPOINT_TOP_BAR_MEDIUM = BREAKPOINT_MEDIUM;

export const MARKETING_PAGE_BREAKPOINT_TABLET_VALUE = 768;
export const MARKETING_PAGE_BREAKPOINT_DESKTOP_VALUE = 1024;

export const MARKETING_PAGE_BREAKPOINT_TABLET = `${MARKETING_PAGE_BREAKPOINT_TABLET_VALUE}px`;
export const MARKETING_PAGE_BREAKPOINT_DESKTOP = `${MARKETING_PAGE_BREAKPOINT_DESKTOP_VALUE}px`;
